// Access denials are neither a connection failure nor a financial outcome.
// Only navigate using the KYC path supplied by our own JSON response.
export const isAccessDenied = response => response.status === 401 || response.status === 403

export async function readResponse(response) {
  try {
    const data = await response.json()
    return data && typeof data === 'object' && !Array.isArray(data) ? data : {}
  } catch (_error) {
    return {}
  }
}

export function messageFor(response, data, messages) {
  if (typeof data.error === 'string' && data.error.trim()) return data.error
  return response.status === 401 ? messages.sessionRequired : messages.accessDenied
}

export function onboardingPath(data) {
  const path = data.onboarding_path
  if (data.error_code !== 'kyc_required' || typeof path !== 'string' ||
      !path.startsWith('/') || path.startsWith('//') || /[\\\s\u0000-\u001f\u007f]/.test(path)) return null
  try {
    const target = new URL(path, window.location.origin)
    if (target.origin !== window.location.origin) return null
    return `${target.pathname}${target.search}${target.hash}`
  } catch (_error) {
    return null
  }
}

export async function announce(response, data, messages) {
  await window.ArcadiDialog.alert(messageFor(response, data, messages))
  const path = onboardingPath(data)
  if (path) window.location.assign(path)
}
